import { Injectable } from '@angular/core';
import { FileSaverService } from '../fileSaver.service';

@Injectable()
export class CsvExportService {
  constructor(private fileSaverService: FileSaverService) {}

  exportToCSV(data: any[], filename: string): void {
    if (!data || data.length === 0) {
      return;
    }

    const csvContent = this.convertToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    this.fileSaverService.saveFile(blob, filename);
  }

  private convertToCSV(data: any[]): string {
    // Crea l'intestazione del CSV con i nomi delle proprietà
    const header = Object.keys(data[0]).join(',');

    // Crea il corpo del CSV, gestendo le virgole nei valori
    const rows = data
      .map((row) => {
        return Object.values(row)
          .map((value) => `"${String(value).replace(/"/g, '""')}"`)
          .join(',');
      })
      .join('\n');

    // Ritorna il CSV completo
    return `${header}\n${rows}`;
  }
}
